/* global currentLanguage */
import domReady from '@wordpress/dom-ready';
import manifest from './../manifest.json';
import timelineContentManifest from './../../../custom/timeline-content/manifest.json';

domReady(async () => {
	const containerSelector = `.${manifest.componentJsClass}-loaded-items`;
	const templateSelector = `.${manifest.componentJsClass}-template`;
	const titleSelector = `.${manifest.componentJsClass}-title-content`;
	const contentSelector = `.${manifest.componentJsClass}-content`;
	const itemSelector = `.${manifest.componentJsClass}-single`;

	const timelineContentClass = timelineContentManifest.blockJsClass;
	const timelineContentSelector = `${containerSelector} .${timelineContentClass}`;
	const timelineContentInnerContent = `${timelineContentSelector}-inner-content`;
	const timelineContentToggleButton = `${timelineContentSelector}-toggle-content-button`;

	const container = document.querySelector(containerSelector);
	let titles = document.querySelectorAll(titleSelector);

	let startPage = manifest.attributes.productUpdatesStartPage.default;
	let postsPerPage = manifest.attributes.productUpdatesPostsPerPage.default;

	// Use WPML current language - add prefix only if not English
	const currentLang = typeof currentLanguage !== 'undefined' && currentLanguage?.[0]?.length ? currentLanguage?.[0] : 'en';
	const languagePrefix = currentLang && currentLang !== 'en' ? `/${currentLang}` : '';
	const loadMoreBaseUrl = `${window.location.origin}${languagePrefix}/wp-json/wp/v2/product-updates/`;

	if (!container || !titles) {
		return;
	}

	// When enabled, only the newest update stays expanded; older ones start collapsed.
	const root = container.closest(`.${manifest.componentJsClass}`);
	const collapseOlder = root?.dataset.collapseOlder === 'true';

	const { LoadMorePosts } = await import('./load-more-posts');

	const loadMorePosts = new LoadMorePosts({
		containerSelector,
		templateSelector,
		titleSelector,
		contentSelector,
		startPage,
		postsPerPage,
		loadMoreBaseUrl,
		timelineContentSelector,
		timelineContentInnerContent,
		timelineContentToggleButton,
		collapseOlder,
	});

	loadMorePosts.init();

	// Collapse the timeline content of every server-rendered update except the newest one.
	if (!collapseOlder || !root) {
		return;
	}

	const olderBlocks = [];

	root.querySelectorAll(itemSelector).forEach((single, index) => {
		if (index === 0) {
			return;
		}

		olderBlocks.push(...single.querySelectorAll(`.${timelineContentClass}`));
	});

	if (!olderBlocks.length) {
		return;
	}

	const { applyCollapsedState } = await import('./timeline-content-toggle-helper');
	applyCollapsedState(olderBlocks);
});
